import difference from 'lodash-es/difference';
import { call, put, select, takeLatest } from 'redux-saga/effects';

import type Store from '~/types/Store';

import { ActionKeys } from '~/actions/constants';
import * as storeActions from '~/actions/stores.actions';
import { FIRST_STORE_CONNECTED } from '~/constants/gtm';
import { getConnectedStores } from '~/selectors/stores.selectors';
import { sendGTMEvent } from '~/services/gtm.service';
import * as storeServices from '~/services/stores.service';
import { fromJSON } from '~/types/Store';
import { readFromLocalStorage, saveInLocalStorage } from '~/utils/local-storage';

export function* fetchStores() {
  try {
    const response = yield call(storeServices.fetchStores);
    const stores = response.data.results.map(fromJSON);
    yield put(storeActions.fetchStoresSuccess(stores));
    yield call(checkAndTrackStoreConnectionBehavior);
  } catch (err) {
    yield put(storeActions.fetchStoresError(err.toString()));
  }
}

function* checkAndTrackStoreConnectionBehavior() {
  const connectedStores: Store[] = yield select(getConnectedStores);
  const currentlyConnectedStoreNames = connectedStores.map((x) => x.storePlatform.name);
  const persistedStores = readFromLocalStorage('stores');
  const updateStoresCookie = () =>
    saveInLocalStorage('stores', JSON.stringify(currentlyConnectedStoreNames));
  if (persistedStores) {
    const parsedPersistedStores: readonly string[] = JSON.parse(persistedStores);

    if (parsedPersistedStores.length !== connectedStores.length) {
      const storeName = difference(parsedPersistedStores, currentlyConnectedStoreNames);
      if (parsedPersistedStores.length === 0 && connectedStores.length === 1) {
        yield call(sendGTMEvent, {
          data: {
            store: storeName,
          },
          eventName: FIRST_STORE_CONNECTED,
        });
      }
      updateStoresCookie();
    }
  } else {
    updateStoresCookie();
  }
}

export default [takeLatest(ActionKeys.STORES_FETCH, fetchStores)];
